
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import SPUService from '@/services/spu.service';

@Component
export default class ImageIibraryModal extends Vue {
  visible = false;

  objDate: any = {};

  objPhoto: any = {};

  changeKey: any = '';

  value: any = '';

  @lazyInject(SPUService)
  protected spuService!: SPUService;

  async init(item: any) {
    console.log(item);
    const res = await this.spuService.getSpuCategoryPhotoDelete(item.id);
    console.log(res);
    if (Object.prototype.toString.call(res) === '[object Object]') {
      const keys = Object.keys(res) as string[];
      console.log(keys);
      this.objPhoto = keys;
      this.changeKey = keys[0] || '';
      this.objDate = res;
      this.visible = true;
    }
  }

  handleOk() {}

  handleCancel() {
    this.visible = false;
  }
  onChange(e: any) {
    console.log(e);
  }
}
